// Simple company logos infinite scroll - CSS animation only
console.log('Loading company logos infinite scroll');

function initInfiniteScroll() {
  const container = document.querySelector('.company-logos-container');
  const scrollElement = document.querySelector('.company-logos-scroll');
  
  console.log('Elements found:', !!container, !!scrollElement);
  
  if (!container || !scrollElement) {
    console.log('Company logos elements not found');
    return;
  }
  
  // Ensure CSS animation is properly applied
  scrollElement.style.animation = 'scroll-logos 60s linear infinite';
  scrollElement.style.animationPlayState = 'running';
  
  // Only add hover pause functionality
  container.addEventListener('mouseenter', () => {
    scrollElement.style.animationPlayState = 'paused';
    console.log('Animation paused on hover');
  });
  
  container.addEventListener('mouseleave', () => {
    scrollElement.style.animationPlayState = 'running';
    console.log('Animation resumed after hover');
  });
  
  console.log('Infinite scroll initialized with CSS animation');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
} else {
  initInfiniteScroll();
} 